import { render } from "./AnalyticsForWorkshop.vue?vue&type=template&id=cab4c59e"
import script from "./AnalyticsForWorkshop.vue?vue&type=script&lang=js"
export * from "./AnalyticsForWorkshop.vue?vue&type=script&lang=js"

import "./AnalyticsForWorkshop.vue?vue&type=style&index=0&id=cab4c59e&lang=css"

import exportComponent from "/home/runner/work/webapp/webapp/main/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__